<template>
  <div>
    <div class="table-header row">
      <div>
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
      </div>
      <div>
        上传时间
      </div>
      <div style="line-height:30px;">
        文件名/备注
      </div>
      <div>
        大小/MD5
      </div>
      <div>上传人</div>
      <div>关联任务数</div>
      <div>使用流量</div>
      <div>操作</div>
    </div>
    <div class="table-body">
      <div
        class="row"
        v-for="(item, index) in fileTableList"
        :key="index"
      >
        <!-- 选中 -->
        <div>
          <input
            type="checkbox"
            @click.stop
            v-model="item.select"
            @change="selectChange(item.select)"
          />
        </div>
        <!-- 上传时间 -->
        <div class="twoLine">
          <p v-text="item.createTime.split('T')[0]"></p>
          <p v-text="item.createTime.split('T')[1]"></p>
        </div>
        <!-- 文件名/备注 -->
        <div class="editMark">
          <p v-text="item.fileName"></p>
          <span
            v-text="item.remark"
            v-show="!item.editState"
          ></span>
          <img
            src="@/assets/img/icon/u654.svg"
            alt=""
            v-show="!item.editState"
            @click.prevent="item.editState = true"
          />
          <input
            type="text"
            v-model="item.editName"
            v-show="item.editState"
          />
          <div
            v-show="item.editState"
            style="display:inline-block;"
          >
            <a
              href="#"
              @click.prevent="saveEdit(item)"
            >保存</a>
            <a
              href="#"
              @click.prevent="item.editState = false"
            >取消</a>
          </div>
        </div>
        <!-- 大小/MD5-->
        <div class="twoLine">
          <p v-text="item.fileSizeByte"></p>
          <p v-text="item.md5"></p>
        </div>
        <!-- 上传人 -->
        <div class="twoLine">
          <p v-text="item.createBy"></p>
          <p v-if="item.accountType == 0">主账号</p>
          <p v-if="item.accountType == 2">员工账号</p>
          <p v-if="item.accountType == 3">业主账号</p>
        </div>
        <!-- 关联任务数 -->
        <div>
          <span v-text="$PropFn.safeDislayValue(item.relatedTaskNum)"></span>
        </div>
        <!-- 使用流量 -->
        <div>
          <span v-text="item.useFlowByte"></span>
        </div>
        <!-- 操作 -->
        <div class="operate">
          <a
            href="#"
            @click.prevent.stop="delFile(item)"
          >删除文件</a>
        </div>
      </div>
      <no-data
        style="height:auto;padding-top:20px;padding-bottom:20px;"
        v-show="tableList.length == 0 || loading"
        :nodata="tableList.length == 0 && !loading"
        :loading="loading"
      ></no-data>
    </div>
    <div
      class="table-pagination"
      v-show="tableList.length > 0"
    >
      <div style="float:left;padding-left:6px;">
        <input
          type="checkbox"
          v-model="isSelectAll"
          @change="selectAllChange"
        />
        <div
          class="default-btn com"
          @click.prevent="delAllFile"
        >
          <span>删除</span>
        </div>
      </div>
      <page-component
        :total="total"
        :display="30"
        :current-page="page"
        @pagechange="pagechange"
      ></page-component>
    </div>
    <del-file></del-file>
  </div>
</template>

<script>
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";
import delFile from "../modal/delFile";
import { editRemark } from "@/requests/threeTierMission";
import { bytesToSize } from "@/utils/byte.js";
import { Base64 } from "js-base64";
export default {
  name: "tableData",
  components: {
    PageComponent,
    NoData,
    delFile,
  },
  props: {
    tableList: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSelectAll: false,
      fileTableList: [],
    };
  },
  watch: {
    tableList() {
      this.isSelectAll = false;
      let arr = JSON.parse(JSON.stringify(this.tableList));
      arr.forEach((item) => {
        item.fileSizeByte = bytesToSize(item.fileSize);
        item.useFlowByte = bytesToSize(item.useFlow);
        item.select = false;
        item.editState = false;
        item.editName = item.remark;
      });
      this.fileTableList = arr;
    },
  },
  methods: {
    selectedFileIds() {
      let arr = [];
      this.fileTableList.forEach((item) => {
        if (item.select) {
          arr.push(item.fileId);
        }
      });
      return arr;
    },
    pagechange(page) {
      this.$emit("pagechange", page);
    },
    selectAllChange() {
      if (this.isSelectAll) {
        this.fileTableList.forEach((item) => {
          item.select = true;
        });
      } else {
        this.fileTableList.forEach((item) => {
          item.select = false;
        });
      }
    },
    selectChange(selectState) {
      if (selectState) {
        // 对单项进行选中
        // 判断是否全部选中
        let selectAllState = this.fileTableList.every((item) => {
          return item.select == true;
        });
        // 若全部选中,则为全选状态
        if (selectAllState) {
          this.isSelectAll = true;
        }
      } else {
        // 对单项进行取消
        this.isSelectAll = false;
      }
    },
    async delFile(item) {
      // console.log(322)
      // console.log(item)
      if (item.relatedTaskNum > 0) {
        window.$Message.show({
          title: "删除文件",
          type: "error",
          msg:
            "该文件已关联到任务，如需删除请先删除相关任务。",
          confirmFn: async () => {
            window.$Message.hide();
          }
        });
        return false
      }
      let res = await window.$modal.delFileModal.show(
        item.fileId,
        item.fileName
      );
      if (res) {
        this.$emit(
          "refresh",
          this.$del.delPage(this.total, 1, 30, this.page)
        );
        // window.$Message.show({
        //   title: "删除文件",
        //   type: "success",
        //   msg:
        //     "删除成功！",
        //   confirmFn: async () => {
        //     window.$Message.hide();
        //   }
        // });
        // this.$domFn.shake(res);
        this.$Notice.success({
          title: "文件删除成功！",
        });
      }
    },
    delAllFile() {
      this.fileTableList.forEach((item) => {
        if (item.relatedTaskNum > 0 && item.select == true) {
          window.$Message.show({
            title: "删除文件",
            type: "error",
            msg:
              "该文件已关联到任务，如需删除请先删除相关任务。",
            confirmFn: async () => {
              window.$Message.hide();
            }
          });
          this.canDelete = true
        }
      });
      if (!this.canDelete) {
        this.$emit("delAllFile");
      }
      //
    },
    async saveEdit(item) {
      let res = await editRemark({
        fileId: item.fileId,
        remark: Base64.encode(item.editName).replace(/\+/g, "%2B"),
      });
      if (res.code == 200) {
        this.$emit("refresh");
      } else {
        /* eslint-disable */
        console.log(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
  width: 100%;
  cursor: pointer;
  @include clearfix();
  &:after {
    content: "";
    top: 0;
    left: 0;
    display: block;
    font-size: 0;
    height: 0;
    width: 0;
    clear: both;
    visibility: hidden;
  }
  > div {
    float: left;
    text-align: left;
    text-overflow: ellipsis;
    height: 50px;
    span {
      @include ellipsis();
      max-width: 100%;
    }
    p {
      @include ellipsis();
      max-width: 100%;
    }
    a {
      display: inline;
      text-align: left;
      text-indent: 0px;
      margin-right: 5px;
      color: rgb(0, 102, 204);
    }
    .disable {
      color: #7f7f7f;
    }
    input {
      cursor: pointer;
    }
  }

  > div:nth-child(1) {
    width: 25px;
    text-indent: 6px;
    input {
      position: relative;
      top: 2px;
    }
  }
  > div:nth-child(2) {
    width: 10%;
    @include ellipsis();
  }
  > div:nth-child(3) {
    width: 23%;
    @include ellipsis();
    line-height: normal;
  }
  > div:nth-child(4) {
    width: 20%;
    @include ellipsis();
  }
  > div:nth-child(5) {
    width: 8%;
    @include ellipsis();
  }
  > div:nth-child(6) {
    width: 8%;
    @include ellipsis();
  }
  > div:nth-child(7) {
    width: 8%;
    @include ellipsis();
  }
  > div:nth-child(8) {
    width: 10%;
    @include ellipsis();
  }
}

.table-header {
  > div {
    height: 30px;
    line-height: 30px;
  }
}

.twoLine {
  p {
    line-height: normal;
    line-height: 16px;
  }
  p:nth-child(1) {
    padding-top: 10px;
  }
  p:nth-child(2) {
    color: #a1a1a1;
  }
}
.editMark {
  p {
    line-height: normal;
    line-height: 16px;
    padding-top: 10px;
  }
  span {
    color: #a1a1a1;
    display: inline-block;
    max-width: 90% !important;
  }
  img {
    margin-left: 5px;
    position: relative;
    top: 1px;
  }
  input {
    max-width: 65%;
    height: 20px;
    border: 1px solid rgba(2, 167, 240, 1);
    background: #fff;
    padding-left: 5px;
    margin-right: 5px;
  }
}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;
  > div {
    display: inline-block;
    .com {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
input[type="checkbox"] {
  cursor: pointer;
}
</style>
